import Loading from "vue-loading-overlay";
export default {
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            operationType: '',
            getShippingIntructionURL : 'get-shipping-instruction',
            shippingInstruction: [],  
        }
    },
    mounted() {
        this.$emit('updatePurchaseCartBox', 0);  
        this.$emit('updateMySellCart', 0);  
        this.$emit('updateLoginStatus', true);  
    },
    created() {
        this.getShippingInstruction(); 
    },
    methods: {
        getShippingInstruction: function() {
            console.log('invoiceID = ', this.$route.params.invoiceID);
            this.isLoading = true;
            let invoiceID=this.$route.params.invoiceID;
            this.$axios.get(this.$api + 'api/' + this.getShippingIntructionURL+'/'+invoiceID).then(response => {
                this.shippingInstruction = response.data.data;
                this.operationType=response.data.datatypes;
                console.log('this.operationType = ', this.operationType);
                console.log('this.response.data.datatypes = ', response.data.datatypes);
                this.isLoading = false;
            }).catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        },
        backtoNewSales: function() {
            if(this.operationType=="Sales")
            {      
                this.$router.push({name:'buydevice'});
            }  
            else
            {
                this.$router.push({name:'Sell-Device'});
            }   
        }
    }
}